import { SOURCE_ENDPOINTS, FILTER_DEFINITIONS, FILTER_VALUE_OPTIONS } from '../JobsList/dataSourceConstants';

/**
 * Gets available endpoints for a selected data source
 * @param {string} dataSourceId - The ID of the selected data source
 * @returns {Array} - List of available endpoints
 */
export const getEndpointsForDataSource = (dataSourceId) => {
  return SOURCE_ENDPOINTS.filter(endpoint => endpoint.dataSourceId === dataSourceId);
};

/**
 * Gets available filter definitions for a selected endpoint
 * @param {string} endpointId - The ID of the selected endpoint
 * @returns {Array} - List of available filter definitions
 */
export const getFiltersForEndpoint = (endpointId) => {
  return FILTER_DEFINITIONS.filter(filter => filter.endpointId === endpointId);
};

/**
 * Gets available filter options for a specific filter
 * @param {string} filterId - The ID of the filter
 * @returns {Array} - List of available filter options
 */
export const getOptionsForFilter = (filterId) => {
  return FILTER_VALUE_OPTIONS.filter(option => option.filterId === filterId);
};

/**
 * Checks if a field has an error
 * @param {Object} formik - The Formik instance
 * @param {string} field - The field name to check
 * @returns {boolean} - Whether the field has an error
 */
export const hasError = (formik, field) => {
  return formik.touched[field] && Boolean(formik.errors[field]);
};

/**
 * Gets the error message for a field
 * @param {Object} formik - The Formik instance
 * @param {string} field - The field name
 * @returns {string} - The error message
 */
export const getErrorMessage = (formik, field) => {
  return formik.touched[field] ? formik.errors[field] : '';
};

/**
 * Checks if a nested field has an error
 * @param {Object} formik - The Formik instance
 * @param {string} parent - The parent field name
 * @param {string} field - The nested field name
 * @returns {boolean} - Whether the nested field has an error
 */
export const hasNestedError = (formik, parent, field) => {
  return (
    formik.touched[parent] &&
    formik.touched[parent][field] &&
    formik.errors[parent] &&
    Boolean(formik.errors[parent][field])
  );
};

/**
 * Gets the error message for a nested field
 * @param {Object} formik - The Formik instance
 * @param {string} parent - The parent field name
 * @param {string} field - The nested field name
 * @returns {string} - The error message
 */
export const getNestedErrorMessage = (formik, parent, field) => {
  if (
    formik.touched[parent] &&
    formik.touched[parent][field] &&
    formik.errors[parent]
  ) {
    return formik.errors[parent][field];
  }
  return '';
};

/**
 * Formats a value for display in the UI
 * @param {any} value - The value to format
 * @param {string} type - The type of formatting to apply
 * @returns {string} - The formatted value
 */
export const formatValue = (value, type) => {
  if (value === null || value === undefined) {
    return '';
  }
  
  switch (type) {
    case 'json':
      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2);
      }
      return value;
    case 'date':
      if (value instanceof Date) {
        return value.toISOString();
      }
      return value;
    default:
      return String(value);
  }
};